export default __webpack_public_path__ + "static/media/wave.90023cd7.png";